import { render, staticRenderFns } from "./WidgetGraphForm.vue?vue&type=template&id=863e90b6"
import script from "./WidgetGraphForm.vue?vue&type=script&lang=js"
export * from "./WidgetGraphForm.vue?vue&type=script&lang=js"
import style0 from "./WidgetGraphForm.vue?vue&type=style&index=0&id=863e90b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports